import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import FullbleedHero from '../components/ContentBlocks/FullbleedHero';
import ContactForm from '../components/ContactForm';
import { fetchContact } from '../redux/actions';
import { connect } from 'react-redux';
import Loader from '../components/Loader';
import './ContactPage.css';
import ReactMarkdown from 'react-markdown';
import Helmet from 'react-helmet';

class ContactPage extends Component {

  componentDidMount()
  {
    const locale = this.props.intl.locale;
    if (!this.props.contact.header) {
      this.props.fetchContact(locale);
    }
  }

  render() {
    return (
      <div className="contact">
        <Helmet>
          <title>{this.props.intl.messages["header.contactUs"]}</title>
        </Helmet>
        {!this.props.contact.header && <Loader/>}
        {this.props.contact.header && <FullbleedHero fields={this.props.contact.header}/>}
        <div className="contact-body">
          <div className="container">
            <div className="row">
              <div id="open-hours">
                <div>
                  <h3 className="cacheover"><FormattedMessage id="contact.onlineInvoices" /></h3>
                  {!this.props.contact.onlineInvoices && <Loader/>}
                  {this.props.contact.onlineInvoices && <ReactMarkdown source={this.props.contact.onlineInvoices} softBreak="br" />}
                </div>
              </div>
              <div>
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ContactPage.propTypes = {
  intl: intlShape.isRequired,
}

const mapStateToProps = state => ({
  contact:state.contact,
  hours:state.hours
});

const mapDispatchToProps = {
  fetchContact
};

export default connect(mapStateToProps,mapDispatchToProps)(injectIntl(ContactPage));



// WEBPACK FOOTER //
// ./src/containers/ContactPage.js